module.exports = "/images/motoicon-white.svg?a73f8ef62d5122f55d6d5cf45838570d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/motoicon-white.svg
// module id = CmB/
// module chunks = 1